// removed by extract-text-webpack-plugin
module.exports = {"Icon":"ToolbarIcon__Icon__22QNo","Label":"ToolbarIcon__Label__1UBWV","Link":"ToolbarIcon__Link__2ot_6","Active":"ToolbarIcon__Active__3h7tv"};